export const OPTIMIZELY_PROJECT_NAME = 'default';
export const RECEIVED_ASSIGNMENTS = '@@abservice/RECEIVED_ASSIGNMENTS';
export const AB_OVERRIDES_COOKIE_KEY = 'testAbSystemOverrides';
export const AB_ROOT_KEY = 'absystem';

export const VISITOR_ID_TYPES = {
    sessionId: 'sessionId',
    trackingId: 'trackingId',
};

export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';

export const PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP = {
    experimentId: 'pinata_email_first_login_and_signup',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const PINATA_MFA_AUTH = {
    experimentId: 'pinata_mfa_auth',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const EAT_SITE_FOOTER_CONTACT_INFO = {
    experimentId: 'EAT_siteFooterContactInfo',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const API_DOCS_LINK_IN_FOOTER = {
    experimentId: 'api_docs_link_in_footer',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const PINATA_REDIRECT_FROM_WELL_GUIDE_TO_PATIENTHOME = {
    experimentId: 'pinata_tear_down_well_guide',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};
